<script setup>
import LIcon from "@/components/shared/LIcon.vue";
import { useUiStore } from "@/stores/ui";
import router from "@/router";

const uiStore = useUiStore();

const props = defineProps({
  data: Object,
});

const action = async (type, data) => {
  await uiStore.setModalAction(type);
  uiStore.setModalState(true);
  await uiStore.setModalData(data);

  if (type == 'edit_agent_instructions') {
    router.push({ path: '/agent-instructions', query: { id: data.uuid } });
  }
};
</script>

<template>
  <div class="actions-cell">
    <button @click="action('edit_agent_instructions', props.data)" type="button" class="icon-button" title="Edit">
      <LIcon name="pencil" />
    </button>
    <button @click="action('delete_agent_instructions', props.data)" type="button" class="icon-button danger" title="Delete">
      <LIcon name="trash-2" />
    </button>
  </div>
</template>
